module.exports = __webpack_public_path__ + "static/media/Screenshot 2022-07-09 at 10.29.20 PM.92b94a0c.png";